<!-- hypercomb-shared/ui/command-line/command-line.component.html -->

<div class="command-line-wrapper" [style.visibility]="touchDragging() || viewActive() ? 'hidden' : null">
  @if (locked()) {
    <a class="install-prompt" (click)="openDcp()">{{ 'command-line.install-prompt' | t }}</a>
  } @else {
    <hc-command-shell
      #shell
      [suggestions]="suggestions()"
      [placeholder]="placeholder()"
      [ghostValue]="ghostValue()"
      [showSuggestions]="showCompletions()"
      [typedPrefix]="completionTypedPrefix()"
      [descriptionMap]="slashDescriptionMap()"
      [colorMap]="accentColorMap()"
      [indicators]="activeIndicators()"
      [armedResource]="armedResource()"
      [showOpenForSubscribersToggle]="showOpenForSubscribersToggle()"
      [openForSubscribers]="openForSubscribers()"
      [openForSubscribersLabel]="'command-line.open-for-subscribers' | t"
      (valueChange)="onShellValueChange($event)"
      (commit)="onShellCommit($event)"
      (completionAccepted)="onShellCompletionAccepted($event)"
      (shellKeydown)="onShellKeydown($event)"
      (indicatorDismiss)="onIndicatorDismiss($event)"
      (armedResourceDismiss)="onArmedResourceDismiss()"
      (openForSubscribersToggle)="onOpenForSubscribersToggle()"
    />

    @if (voiceSupported && pushToTalkEnabled()) {
      <button class="mic-btn" [class.recording]="voiceActive()"
        (pointerdown)="startVoice($event)" (pointerup)="stopVoice()" (pointerleave)="stopVoice()"
        [attr.aria-label]="'controls.voice' | t" [title]="'controls.voice-hold' | t">
        <span class="mic-dot">{{ voiceActive() ? '●' : '○' }}</span>
      </button>
    }
    <!-- mobile-only GO/submit button: commits text (creating a tile) if any,
         otherwise just collapses the command-line back to hidden. -->
    <button class="mobile-go-btn" type="button" (click)="closeMobileInput()"
      [attr.aria-label]="'command-line.go' | t">
      {{ 'command-line.go' | t }}
    </button>
  }
</div>

<!-- Undo / redo cluster — floats at the bottom-right of the viewport.
     Surfaces briefly on undo/redo activity and stays visible while
     rewound so the keyboard arrows have a clickable counterpart. Save
     As / Merge are selection-driven and live in the history viewer
     header, not here. -->
@if (historyNavVisible() || cursorRewound()) {
  <div class="history-controls-cluster">
    <button class="history-nav-btn history-undo-btn" type="button"
      [disabled]="undoDisabled()"
      (click)="doUndo()"
      [attr.aria-label]="'history.undo' | t"
      [title]="'history.undo' | t">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
    </button>
    <button class="history-nav-btn history-redo-btn" type="button"
      [disabled]="redoDisabled()"
      (click)="doRedo()"
      [attr.aria-label]="'history.redo' | t"
      [title]="'history.redo' | t">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
    </button>
  </div>
}

<hc-hint-bar
  [items]="hintItems()"
  [filter]="hintFilter()"
  [chosen]="hintChosen()"
  [colorMap]="accentColorMap()"
  (pick)="onHintPick($event)"
/>
